import useSalonController from '@admin/api/useSalonController'
import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import RichEditor from '@components/modules/RichEditor/RichEditor'
import useAsyncDebounce from '@hooks/useAsyncDebounce'
import useDebounce from '@hooks/useDebounce'
import useStatic from '@hooks/useStatic'
import React from 'react'
import { Descendant } from 'slate'

export default function SalonConditionsPage() {
    const { salon } = useSalonManagerContext()

    const controller = useSalonController()

    const handleDatabaseSync = useStatic(async (value: Descendant[]) => {
        return controller.conditions(salon.state.id, value)
    })

    const handleChange = useAsyncDebounce(async (value: Descendant[]) => {
        return handleDatabaseSync(value)
    }, 600)

    const handleSave = useStatic((value: Descendant[]) => {
        return handleDatabaseSync(value)
    })

    return <RichEditor value={salon.state.conditions} onSave={handleSave} onChange={handleChange} />
}